import React from 'react';
import { Price } from '@thd-olt-component-react/price';
import PropTypes from 'prop-types';
import { BundlePrice } from './BundlePrice.component';

const ProductPrice = ({ product, isBundle = false }) => {
  if (isBundle) {
    return <BundlePrice bundle={product} />;
  }

  return (
    <Price
      itemId={product.itemId}
      product={product}
      channel="desktop"
      type="simple"
      displayEachUom={false}
      clsRemediation={{
        placeholders: true,
        preservePlaceholders: true
      }}
    />
  );
};

ProductPrice.propTypes = {
  product: PropTypes.shape({
    itemId: PropTypes.string
  }).isRequired,
  isBundle: PropTypes.bool
};


export default ProductPrice;